import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: "d71dc260-4047-4580-90ee-8a589cb370de",
        authority: "https://login.microsoftonline.com/bdcfaa46-3f69-4dfd-b3f7-c582bdfbb820",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "localStorage"
    }
};

//export const loginRequest = {
//    scopes: ["User.Read"]
//};

export const loginRequest = {
    scopes: ["api://d71dc260-4047-4580-90ee-8a589cb370de/access_as_user"]
};